import"./styles.css.ts.vanilla.css";var t="x58f780",n="x58f781";export{t as mainContainer,n as sfccContentStyle};
